import React, { PureComponent } from 'react'
import { Formik, ErrorMessage } from 'formik'
import { Form, Field } from 'formik-antd'
import _ from 'lodash'
import validate from './validation/contactForm'

export default class ContactForm extends PureComponent {
    handleSubmit = (data, setSubmitting) => {
        const { id } = data

        if (id) {
            this.props.actions
                .updateContact(data)
                .then(res => this.props.handleClose())
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                })
        } else {
            this.props.actions
                .addContact(data)
                .then(res => this.props.handleClose())
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                })
        }
    }

    render() {
        const empty = {
            firstName: '',
            lastName: '',
            mobile: '',
            address: '',
            email: '',
            group: '',
        }

        const selectedContact = this.props.data
        const initialValues = _.isEmpty(selectedContact)
            ? empty
            : selectedContact

        return (
            <Formik
                initialValues={initialValues}
                validate={validate()}
                onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                        this.handleSubmit(values, setSubmitting)
                    }, 400)
                }}
            >
                {contactForm => (
                    <Form onSubmit={contactForm.handleSubmit}>
                        <div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row form-group">
                                        <label className="col-xs-3  col-sm-3 col-md-3 control-label">
                                            First Name:{' '}
                                        </label>
                                        <div className="col-xs-9 col-sm-9 col-md-9">
                                            <Field
                                                id="firstName"
                                                name="firstName"
                                                type="text"
                                                className="form-control"
                                                placeholder="First Name"
                                                onChange={
                                                    contactForm.handleChange
                                                }
                                                onBlur={contactForm.handleBlur}
                                                value={
                                                    contactForm.values.firstName
                                                }
                                            />
                                            <div className="errorMsg">
                                                <ErrorMessage name="firstName" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row form-group">
                                        <label className="col-xs-3  col-sm-3 col-md-3 control-label">
                                            Last Name:{' '}
                                        </label>
                                        <div className="col-xs-9 col-sm-9 col-md-9">
                                            <Field
                                                id="lastName"
                                                name="lastName"
                                                type="text"
                                                className="form-control"
                                                placeholder="Last Name"
                                                onChange={
                                                    contactForm.handleChange
                                                }
                                                onBlur={contactForm.handleBlur}
                                                value={
                                                    contactForm.values.lastName
                                                }
                                            />
                                            <div className="errorMsg">
                                                <ErrorMessage name="lastName" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row form-group">
                                        <label className="col-xs-3  col-sm-3 col-md-3 control-label">
                                            Mobile:{' '}
                                        </label>
                                        <div className="col-xs-9 col-sm-9 col-md-9">
                                            <Field
                                                id="mobile"
                                                name="mobile"
                                                type="text"
                                                className="form-control"
                                                placeholder="Mobile"
                                                onChange={
                                                    contactForm.handleChange
                                                }
                                                onBlur={contactForm.handleBlur}
                                                value={
                                                    contactForm.values.mobile
                                                }
                                            />
                                            <div className="errorMsg">
                                                <ErrorMessage name="mobile" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row form-group">
                                        <label className="col-xs-3  col-sm-3 col-md-3 control-label">
                                            Address:{' '}
                                        </label>
                                        <div className="col-xs-9 col-sm-9 col-md-9">
                                            <Field
                                                id="address"
                                                name="address"
                                                type="text"
                                                className="form-control"
                                                placeholder="Address"
                                                onChange={
                                                    contactForm.handleChange
                                                }
                                                onBlur={contactForm.handleBlur}
                                                value={
                                                    contactForm.values.address
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row form-group">
                                        <label className="col-xs-3  col-sm-3 col-md-3 control-label">
                                            Email:{' '}
                                        </label>
                                        <div className="col-xs-9 col-sm-9 col-md-9">
                                            <Field
                                                id="email"
                                                name="email"
                                                type="text"
                                                className="form-control"
                                                placeholder="Email"
                                                onChange={
                                                    contactForm.handleChange
                                                }
                                                onBlur={contactForm.handleBlur}
                                                value={contactForm.values.email}
                                            />
                                            <div className="errorMsg">
                                                <ErrorMessage name="email" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row form-group">
                                        <label className="col-xs-3  col-sm-3 col-md-3 control-label">
                                            Group:{' '}
                                        </label>
                                        <div className="col-xs-9 col-sm-9 col-md-9">
                                            <Field
                                                id="group"
                                                name="group"
                                                type="text"
                                                className="form-control"
                                                placeholder="Group"
                                                onChange={
                                                    contactForm.handleChange
                                                }
                                                onBlur={contactForm.handleBlur}
                                                value={contactForm.values.group}
                                            />
                                        </div>
                                    </div>
                                    {/* <div className="row form-group">
                                        <div className="col-xs-9 col-sm-9 col-md-9">
                                            <Checkbox
                                                id="enable"
                                                name="enable"
                                                onChange={e =>
                                                    contactForm.setFieldValue(
                                                        'enable',
                                                        e.target.value
                                                    )
                                                }
                                                name="reply"
                                                value={
                                                    contactForm.values.enable
                                                }
                                                checked={
                                                    contactForm.values.enable
                                                }
                                            >
                                                Enable
                                            </Checkbox>
                                        </div>
                                    </div> */}
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    data-dismiss="modal"
                                    onClick={this.props.handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-success"
                                    disabled={contactForm.isSubmitting}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        )
    }
}
